import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Overview-index-1992f2b836bb2df10-1'),
    routerUrl: '/Overview',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Overview')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Overview-index-1992f2b836bb2df10-2'),
        routerUrl: '/OverviewForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./OverviewForm')),
      },
      //$MORE$
    ],
  },
];
